module.exports = __webpack_public_path__ + "assets/img/vip-card.f165b052.png";